import { render, staticRenderFns } from "./CulvertAssetView.vue?vue&type=template&id=67dc2839"
import script from "./CulvertAssetView.vue?vue&type=script&lang=ts"
export * from "./CulvertAssetView.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports